module.exports = __webpack_public_path__ + "media/images/playcanvas-logo-7182f37714a81cc202474bb89a9b6da3.png";